

import { Link } from 'react-router-dom';
import '../App.css';


const page = () => {
  return (
    <div>
      <div className="menu-container">
        <div className="menu">
          <div className="date">
            Contact US
          </div>
          <div className="signup"><Link to="/">Home</Link></div>
          <div className="login">
            {/* Login */}
          </div>
        </div>
      </div>
      <main className="main-container"> 
        <div className="contact-main">  
          <div className="contact-info">
            <span className="contact-title">Office</span>
          </div>
        <span className="contact-title">Address:</span>
            <p className="contact-desc">Aşık veysel Mahallesi Kemal sunal sokak Semerkand Residance kat:9 daire:70 Esenkent-Esenyurt/iSTANBUL</p>
        <span className="contact-title">Email:</span>
            <p className="contact-desc">omidabbaspour1020@gmail.com</p>
        <span className="contact-title">Tell:</span>
          <p className="contact-desc">+90 212 709 86 96</p>
        </div>
      </main>
      <div class="footer">
        <div class="footer-item footer-one">
          <ul class="footer-menu">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/privacyPolicy">Privacy Policy</Link></li>
            <li><Link to="/contactus">Contact Us</Link></li>
          </ul>
        </div>
      </div>
    </div>
    );
  };
  
  export default page;
  


        